import React from 'react';
import {Link} from 'react-router-dom'
import UnAuthorizedPage from './UnAuthorizedPage';
import LoginFormContainer from '../containers/LoginFormContainer';
import UnAuthorizedHeader from '../components/UnAuthorizedHeader'
import translate from '../lib/i18n/translate'

const LoginPage = (props) => {

    const {LoginForgot, LoginHeader, LoginText, Username, Password, Login} = props.strings;

    return (
        <UnAuthorizedPage>
            <UnAuthorizedHeader header={LoginHeader} text={LoginText} />
            <LoginFormContainer username={Username} password={Password} login={Login}/>
            <Link to="/forgot">{LoginForgot}</Link>
        </UnAuthorizedPage>
    );
};

export default translate('LoginPage')(LoginPage);



// WEBPACK FOOTER //
// ./src/pages/LoginPage.js